import { render, staticRenderFns } from "./BooksInTransfer.vue?vue&type=template&id=58031253&scoped=true&"
import script from "./BooksInTransfer.vue?vue&type=script&lang=js&"
export * from "./BooksInTransfer.vue?vue&type=script&lang=js&"
import style0 from "./BooksInTransfer.vue?vue&type=style&index=0&id=58031253&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58031253",
  null
  
)

export default component.exports